<template>
  <v-dialog
    v-model="ModalAdd"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on: modal, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn small fab text v-bind="attrs" v-on="{ ...tooltip, ...modal }">
            <v-icon>mdi-plus-box</v-icon>
          </v-btn>
        </template>
        <span>Tambah Riwayat</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-toolbar dark color="primary" dense flat>
        <v-toolbar-title class="subtitle-1">
          Tambah Riwayat Sasaran Kinerja Pegawai
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeModal()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form ref="form">
        <div class="mx-5 mt-5">
          <v-row>
            <v-col cols="12" md="4">
              <strong> Tahun </strong>

              <v-text-field
                v-model="tahun"
                class="mt-2"
                type="number"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <div class="mx-5 mt-5" v-if="tahun < 2022">
          <v-alert type="error">
            Silahkan pilih tahun SKP <strong>Lama (2022 Kebawah)</strong> pada
            tabel terlebih dahulu untuk melakukan pengimputan
            <strong>SKP Lama</strong>
          </v-alert>
        </div>

        <div class="mx-5 pb-5 mt-n5" v-else>
          <v-card outlined color="blue lighten-4" class="pa-1 mb-6 text-center">
            <strong>Kinerja</strong>
          </v-card>

          <div>
            <v-row>
              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="12" md="4">
                    <strong> Hasil Kinerja</strong>

                    <v-select
                      v-model="hasilKinerjaNilai"
                      class="mt-2"
                      :items="hasil_kinerja"
                      placeholder="Pilih Nilai Hasil Kerja"
                      item-value="id"
                      item-text="id"
                      outlined
                      dense
                      return-object
                      :rules="fRules"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="8">
                    <strong> Rating Perilaku Kinerja </strong>

                    <v-text-field
                      v-model="hasilKinerjaNilai.nama"
                      class="mt-2"
                      outlined
                      dense
                      filled
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="12" md="4">
                    <strong> Perilaku Kerja </strong>

                    <v-select
                      v-model="perilakuKerjaNilai"
                      class="mt-2"
                      :items="perilaku_kerja"
                      placeholder="Pilih Nilai Perilaku Kerja"
                      item-value="id"
                      item-text="id"
                      outlined
                      dense
                      return-object
                      :rules="fRules"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="8">
                    <strong> Rating Perilaku Kerja </strong>

                    <v-text-field
                      v-model="perilakuKerjaNilai.nama"
                      class="mt-2"
                      outlined
                      dense
                      filled
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="mt-n7">
              <v-col cols="12" md="6">
                <strong> Kuadran Kinerja </strong>

                <v-text-field
                  v-model="kuadranKinerjaNilai.id"
                  class="mt-2"
                  outlined
                  dense
                  filled
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <strong> Rating Kuadran Kinerja </strong>

                <v-text-field
                  v-model="kuadranKinerjaNilai.nama"
                  class="mt-2"
                  outlined
                  dense
                  filled
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-card
            outlined
            color="blue lighten-4"
            class="pa-1 mb-6 mt-2 text-center"
          >
            <strong>Pejabat Penilai</strong>
          </v-card>

          <div>
            <v-row>
              <v-col cols="12" md="6">
                <strong> Status Penilai </strong>

                <v-radio-group v-model="penilaiStatus" row>
                  <v-radio label="ASN" value="ASN"></v-radio>
                  <v-radio label="Non ASN" value="NON ASN"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" md="6" v-if="penilaiStatus">
                <strong> NIP Pejabat Penilai </strong>

                <v-text-field
                  v-model="penialaiNip"
                  class="mt-2"
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  :rules="fRules"
                ></v-text-field>
              </v-col>
            </v-row>

            <div v-if="penilaiStatus">
              <v-row class="mt-n7">
                <v-col cols="12" md="6">
                  <strong> Nama Pejabat Penilai </strong>

                  <v-text-field
                    v-model="penilaiNama"
                    class="mt-2"
                    outlined
                    dense
                    :rules="fRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <strong> Golongan Pejabat Penilai </strong>

                  <v-select
                    v-model="penilaiGolongan"
                    :items="refGolongan"
                    class="mt-2"
                    item-value="id"
                    item-text="nama"
                    outlined
                    dense
                    :rules="fRules"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row class="mt-n7">
                <v-col cols="12" md="6">
                  <strong> Unit Organisasi Pejabat Penilai </strong>

                  <v-text-field
                    v-model="penilaiUnorNama"
                    class="mt-2"
                    outlined
                    dense
                    :rules="fRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <strong> Jabatan Pejabat Penilai </strong>

                  <v-text-field
                    v-model="penilaiJabatanNama"
                    class="mt-2"
                    outlined
                    dense
                    :rules="fRules"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="mt-n7">
                <v-col cols="12" md="12">
                  <strong> Upload Dokumen </strong>

                  <v-file-input
                    class="mt-2"
                    outlined
                    dense
                    flat
                    prepend-icon
                    accept=".pdf"
                    label="Dokumen SKP"
                    placeholder="Pilih File"
                    append-icon="mdi-paperclip"
                    @change="onUpload"
                    :rules="fRules"
                  ></v-file-input>
                </v-col>
              </v-row>

              <v-divider class="mb-5"></v-divider>

              <div class="text-right">
                <v-btn
                  color="primary"
                  :loading="lbtn"
                  :disabled="lbtn"
                  @click="simpan()"
                >
                  Simpan
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import Auth from "@/helper/auth.js";
import getRef from "@/helper/getReferensi.js";

import refreshView from "@/store/asn/rwskp/viewRwskp";

export default {
  data: () => ({
    token: Cookie.get("token"),
    token_siasn: Cookie.get("token_siasn"),
    token_wsbkn: Cookie.get("token_wsbkn"),

    ModalAdd: false,
    lbtn: false,
    get_nip: "",

    tahun: 2022,

    hasilKinerjaNilai: "",
    perilakuKerjaNilai: "",
    kuadranKinerjaNilai: "",
    penilaiStatus: "",
    penialaiNip: "",
    penilaiNama: "",
    penilaiGolongan: "",
    penilaiUnorNama: "",
    penilaiJabatanNama: "",
    doc: "",

    refGolongan: [],

    hasil_kinerja: [],
    perilaku_kerja: [],
    kuadran_kinerja: [],

    fRules: [(value) => !!value || "Tidak Boleh Kosong"],
  }),

  watch: {
    hasilKinerjaNilai() {
      if (this.hasilKinerjaNilai.id == 1 && this.perilakuKerjaNilai.id == 1) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 1);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 1 &&
        this.perilakuKerjaNilai.id == 2
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 2);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 2 &&
        this.perilakuKerjaNilai.id == 1
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 2);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 2 &&
        this.perilakuKerjaNilai.id == 2
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 2);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 3 &&
        this.perilakuKerjaNilai.id == 1
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 3);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 3 &&
        this.perilakuKerjaNilai.id == 2
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 3);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 1 &&
        this.perilakuKerjaNilai.id == 3
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 4);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 2 &&
        this.perilakuKerjaNilai.id == 3
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 4);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 3 &&
        this.perilakuKerjaNilai.id == 3
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 5);
        this.kuadranKinerjaNilai = hasil;
      } else {
        this.kuadranKinerjaNilai = [];
      }
    },

    perilakuKerjaNilai() {
      if (this.hasilKinerjaNilai.id == 1 && this.perilakuKerjaNilai.id == 1) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 1);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 1 &&
        this.perilakuKerjaNilai.id == 2
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 2);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 2 &&
        this.perilakuKerjaNilai.id == 1
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 2);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 2 &&
        this.perilakuKerjaNilai.id == 2
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 2);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 3 &&
        this.perilakuKerjaNilai.id == 1
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 3);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 3 &&
        this.perilakuKerjaNilai.id == 2
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 3);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 1 &&
        this.perilakuKerjaNilai.id == 3
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 4);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 2 &&
        this.perilakuKerjaNilai.id == 3
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 4);
        this.kuadranKinerjaNilai = hasil;
      } else if (
        this.hasilKinerjaNilai.id == 3 &&
        this.perilakuKerjaNilai.id == 3
      ) {
        let hasil = this.kuadran_kinerja.find((value) => value.id == 5);
        this.kuadranKinerjaNilai = hasil;
      } else {
        this.kuadranKinerjaNilai = [];
      }
    },
  },

  async mounted() {
    this.get_nip = this.$route.params.id;
    this.refGolongan = await getRef.Golongan(this.token);
    this.getRef();
  },

  methods: {
    validate() {
      return this.$refs.form.validate();
    },

    reset() {
      this.hasilKinerjaNilai = "";
      this.perilakuKerjaNilai = "";
      this.kuadranKinerjaNilai = "";
      this.penilaiStatus = "";
      this.penialaiNip = "";
      this.penilaiNama = "";
      this.penilaiGolongan = "";
      this.penilaiUnorNama = "";
      this.penilaiJabatanNama = "";
      this.doc = "";
    },

    getRef() {
      const url = process.env.VUE_APP_ASN + "ref/skp";

      this.http
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.hasil_kinerja = res.data.mapData.referensi.hasil_kinerja;
          this.perilaku_kerja = res.data.mapData.referensi.perilaku_kerja;
          this.kuadran_kinerja = res.data.mapData.referensi.kuadran_kinerja;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Auth.logout(this.token);
          } else if (error.response) {
            console.log(error.response.status);
          } else {
            console.log("Error", error.message);
          }
        });
    },

    cari() {
      const url = process.env.VUE_APP_ASN + "kinerja/cari/" + this.penialaiNip;

      let data = {
        siasn_token: this.token_siasn,
      };

      this.http
        .post(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.penilaiNama = res.data.mapData.nama;
          this.penilaiGolongan = res.data.mapData.golongan.id;
          this.penilaiUnorNama = res.data.mapData.unorIndukNama;
          this.penilaiJabatanNama = res.data.mapData.jabatanNama;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            // Auth.logout(this.token)
          } else if (error.response) {
            console.log(error.response.status);
          } else {
            console.log("Error", error.message);
          }
        });
    },

    onUpload(value) {
      this.doc = value;
    },

    async simpan() {
      this.lbtn = true;

      if (this.validate()) {
        const url = process.env.VUE_APP_ASN + "kinerja/nip/" + this.get_nip;

        const data = new FormData();
        data.append("doc", this.doc);
        data.append("tahun", this.tahun);
        data.append("hasilKinerjaNilai", this.hasilKinerjaNilai.id);
        data.append("perilakuKerjaNilai", this.perilakuKerjaNilai.id);
        data.append("kuadranKinerjaNilai", this.kuadranKinerjaNilai.id);
        data.append("penilaiStatus", this.penilaiStatus);
        data.append("penialaiNip", this.penialaiNip);
        data.append("penilaiNama", this.penilaiNama);
        data.append("penilaiUnorNama", this.penilaiUnorNama);
        data.append("penilaiJabatanNama", this.penilaiJabatanNama);
        data.append("penilaiGolongan", this.penilaiGolongan);
        data.append("siasn_token", this.token_siasn);
        data.append("wsbkn_token", this.token_wsbkn);

        this.http
          .post(url, data, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((response) => {
            if (response.data.success) {
              refreshView.commit("refreshData", true);
              refreshView.commit("alert", response.data.message);
              refreshView.commit("berhasilAlert", true);
              refreshView.commit("gagalAlert", false);
              refreshView.commit("success", response.data.success);
            } else {
              refreshView.commit("refreshData", true);
              refreshView.commit("alert", response.data.message);
              refreshView.commit("gagalAlert", true);
              refreshView.commit("berhasilAlert", false);
              refreshView.commit("success", response.data.success);
            }
            this.lbtn = false;
            this.closeModal();
          })
          .catch((error) => {
            if (error.response.status == 401) {
              Auth.logout(this.token);
            } else if (error.response) {
              refreshView.commit("refreshData", true);
              refreshView.commit("alert", error.response.data.message);
              refreshView.commit("gagalAlert", true);
              refreshView.commit("berhasilAlert", false);
              refreshView.commit("success", error.response.data.success);
              console.log(error.response.status);
              this.lbtn = false;
              this.closeModal();
            } else {
              refreshView.commit("refreshData", true);
              refreshView.commit("alert", error.response.data.message);
              refreshView.commit("gagalAlert", true);
              refreshView.commit("berhasilAlert", false);
              refreshView.commit("success", error.response.data.success);
              console.log(error.response.status);
              console.log("Error", error.message);
              this.lbtn = false;
              this.closeModal();
            }
          });
      } else {
        window.scrollTo(0, 0);
        this.lbtn = false;
      }
    },

    closeModal() {
      this.reset();
      this.ModalAdd = false;
    },
  },
};
</script>
